/**
 * Element from strapi API
 */
class Base {
  constructor() {}
  _patch(data) {
    return data;
  }
}

export default Base;
